/* import __COLOCATED_TEMPLATE__ from './status-unread-count.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';

class StatusUnreadCountComponent extends Component {
  get classNames() {
    const { class: clazz, type, unreadCount } = this.args;

    return clsx(
      clazz,
      'unread-count-container',
      unreadCount === 0 ? 'zero-unread' : 'show-unread-container',
      'indicator-only',
      type,
    );
  }
}

export default StatusUnreadCountComponent;
